import axios from 'axios'

// initial state
const state = () => ({
  biomarker: [],
  publicBiomarker: [],
  biomarkerCategories: [],
  publicBiomarkerCategories: [],
})

// getters
const getters = {
  biomarker: ({ biomarker }) => biomarker,
  publicBiomarker: ({ publicBiomarker }) => publicBiomarker,
  biomarkerCategories: ({ biomarkerCategories }) => biomarkerCategories,
  publicBiomarkerCategories: ({ publicBiomarkerCategories }) => publicBiomarkerCategories,
}

// actions
const actions = {
  async getBiomarker({ commit }) {
    const biomarker = (await axios.get('/meta/biomarker/')).data
    commit('setBiomarker', biomarker)
  },
  async getPublicBiomarker({ commit }) {
    const publicBiomarker = (await axios.get('/public/meta/biomarker/')).data
    commit('setPublicBiomarker', publicBiomarker)
  },
  async getBiomarkerCategories({ commit }) {
    const biomarkerCats = (await axios.get('/meta/biomarker_categories/')).data
    commit('setBiomarkerCategories', biomarkerCats)
  },
  async getPublicBiomarkerCategories({ commit }) {
    const biomarkerCats = (await axios.get('/public/meta/biomarker_categories/')).data
    commit('setPublicBiomarkerCategories', biomarkerCats)
  },
}

// mutations
const mutations = {
  setBiomarker(state, biomarker) {
    state.biomarker = biomarker
  },
  setPublicBiomarker(state, publicBiomarker) {
    state.publicBiomarker = publicBiomarker
  },
  setBiomarkerCategories(state, biomarkerCategories) {
    state.biomarkerCategories = biomarkerCategories
  },
  setPublicBiomarkerCategories(state, biomarkerCategories) {
    state.publicBiomarkerCategories = biomarkerCategories
  },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
